import { createSlice } from '@reduxjs/toolkit';
import type { PayloadAction } from '@reduxjs/toolkit';
import UserSettings from '../../models/UserSettings';

/**
 * Значения по умолчанию.
 */

// #D05F33

// #9494b8
// #336699
// #75a3a3

const initialState: UserSettings = {
 color: '#75a3a3',
 backgroundColor: '#75a3a3',
 controlColor: '#75a3a3',
 controlBackgroundColor: '#75a3a3',
 selectedColor: '#75a3a3',
 notSelectedColor: '#e3a67b',
 labelBackgroundColor: '#D05F33',
 successText: 'green',
 tooltipColor: '#75a3a3',
 lightShadow: '#fff2e6',
 dropDownSelectionColor: '#d1e0e0',
 dropDownBorderColor: '#75a3a3',
 dropDownSelected: '#ff6600',
 paginationColor: 'black',
 gridRowHoverColor: '#e5d6fe',
 take: 50,
 skip: 50,
 filterIconColor: '#ffa31a',
 pagingBorderColor: '#f0f5f5',
 paginationSizeArray: [20, 50, 100],
 logoWidthSx: 30,
 logoWidthSm: 30,
 logoWidth600: 30,
 logoWidth800: 30,
 logoWidth1200: 30,
 logoWidth1400: 30,
 //isVostokLogo: true,
};

export const getUserSettings = createSlice({
 name: 'setUserSettings',
 initialState,
 reducers: {
  getUserSettingsData: (state, action: PayloadAction<UserSettings>) => {
   state = action.payload;
   return state;
  },
 },
});

export const { getUserSettingsData } = getUserSettings.actions;

export default getUserSettings.reducer;
